import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the api
 */
export class GPSService extends BaseService {

	constructor() {	
		super();
	}
	
	async getGPSLocations(tractorId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/gpslocations/tractors/' + tractorId + params);		
		return data;		
	}
	
	exportGPSLocations(tractorId, paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/gpslocations/tractors/' + tractorId + '/export' + params);		
	};	
	
	async getGPSLocation(recordId) {
		var data = await this.makeGETRequest('/api/resource/gpslocations/' + recordId);		
		return data;		
	}
	
	async saveGPSlocation(location, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/gpslocations/' + location.recordId, location);
		} else {
			saved = await this.makePOSTRequest('/api/resource/gpslocations', location);
		}
		return saved;		
	}	
	
	async activateGPSlocations(recordIds) {	
		var result = await this.makePUTRequest('/api/resource/gpslocations/activate', recordIds);
		return result;
	}	

	async inactivateGPSlocations(recordId) {	
		var result = await this.makePUTRequest('/api/resource/gpslocations/inactivate', recordId);
		return result;
	}	
	
	async filterGPSlocations(filterRequest) {	
		var result = await this.makePUTRequest('/api/resource/gpslocations/filter', filterRequest);
		return result;
	}
	
	async reReferenceGPSlocations(reRefRequest) {	
		var result = await this.makePUTRequest('/api/resource/gpslocations/re-reference', reRefRequest);
		return result;
	}	
	
	async timeshiftGPSlocations(timeShiftRequest) {	
		var result = await this.makePUTRequest('/api/resource/gpslocations/timeshift', timeShiftRequest);
		return result;
	}		
	
	async recalcGPS(recalcRequest) {	
		var result = await this.makePUTRequest('/api/resource/gpslocations/re-calc', recalcRequest);
		return result;
	}	
	
	async deleteGPSLocations(gpsLocationIds) {
		var data = await this.makeDELETERequest('/api/resource/gpslocations', gpsLocationIds);		
		return data;		
	}
	
	async deleteBulkGPSLocations(bulkRequest) {
		var data = await this.makeDELETERequest('/api/resource/gpslocations/bulk',  bulkRequest);		
		return data;		
	}	
	
}
